import React from 'react';
import { ViewsService } from '../../context/view/ViewService';
import { SearchService } from '../../context/search/SearchService';
import { DocumentsService } from '../../context/documents/DocumentsService';
import { FieldsService } from '../../context/fields/FieldsService';
import { ContentTypesService } from '../../context/contentTypes/ContentTypesService';
import { LocalesService } from '../../context/globalization/LocalesService';
import { CurrentUserService } from '../../context/currentUser/CurrentUserService';
import { UiAdminConfigsService } from '../../context/uiAdminConfigs/UiAdminConfigsService';
import { MsGraphService } from '../../context/msGraph/MsGraphService';
import { ConfigurationService } from '../../context/configuration/ConfigurationService';
import { AssignmentsService } from '../../context/permissions/AssignmentsService';
import { TranslationsService } from '../../context/translations/TranslationsService';
import { IndexesService } from '../../context/indexes/IndexesService';
import { VersionsService } from '../../context/versions/VersionsService';

export interface IServicesContext {
  currentUserService?: CurrentUserService;
  viewsService?: ViewsService;
  fieldsService?: FieldsService;
  contentTypesService?: ContentTypesService;
  searchService?: SearchService;
  documentsService?: DocumentsService;
  localesService?: LocalesService;
  uiAdminConfigsService?: UiAdminConfigsService;
  msGraphService?: MsGraphService;
  configurationService?: ConfigurationService;
  assignmentsService?: AssignmentsService;
  translationsService?: TranslationsService;
  indexesService?: IndexesService;
  versionsService?: VersionsService;
}

const ServicesContext = React.createContext<IServicesContext>({});

export default ServicesContext;
